import type { EnrollmentStatus } from '@/features/activity/api'

export type UserFacingEnrollmentState = 'active' | 'finished'

export const BUCKET_STATUSES: Record<UserFacingEnrollmentState, EnrollmentStatus[]> = {
  active: ['IN_PROGRESS', 'PENDING_REVIEW'],
  finished: ['APPROVED', 'REJECTED', 'EXPIRED']
}
